module.exports = __webpack_public_path__ + "img/recent.c1a492e3.svg";